import { motion } from 'framer-motion';
import React from 'react';

const ConfettiExplosion = () => {
  const confettiColors = [
    "#FF69B4",
    "#00CED1",
    "#1D4ED8",
    "#F472B6",
    "#7DD3FC",
    "#C084FC",
  ];

  const confettiShapes = ["◆", "✦", "✧", "●", "▲", "■", "▿", "★"];

  return (
    <div className="fixed inset-0 pointer-events-none z-60 overflow-hidden">
      {/* Left Side Cannon */}
      <div className="absolute left-0 top-1/2 transform -translate-y-1/2">
        {[...Array(25)].map((_, i) => (
          <motion.div
            key={`left-${i}`}
            className="absolute text-4xl font-bold"
            style={{
              color: confettiColors[Math.floor(Math.random() * confettiColors.length)],
              fontSize: `${Math.random() * 32 + 24}px`,
            }}
            initial={{
              x: 0,
              y: 0,
              opacity: 0,
              scale: 0,
              rotate: 0,
            }}
            animate={{
              x: [0, 200 + Math.random() * 400],
              y: [0, -100 - Math.random() * 200, 100 + Math.random() * 200],
              opacity: [0, 1, 1, 0.8, 0],
              scale: [0, 1.2, 1, 0.8, 0],
              rotate: [0, 360 + Math.random() * 720],
            }}
            transition={{
              duration: 3 + Math.random() * 2,
              repeat: Infinity,
              delay: Math.random() * 4,
              ease: "easeOut",
            }}
          >
            {confettiShapes[Math.floor(Math.random() * confettiShapes.length)]}
          </motion.div>
        ))}
      </div>

      {/* Right Side Cannon */}
      <div className="absolute right-0 top-1/2 transform -translate-y-1/2">
        {[...Array(25)].map((_, i) => (
          <motion.div
            key={`right-${i}`}
            className="absolute text-4xl font-bold"
            style={{
              color: confettiColors[Math.floor(Math.random() * confettiColors.length)],
              fontSize: `${Math.random() * 32 + 24}px`,
            }}
            initial={{
              x: 0,
              y: 0,
              opacity: 0,
              scale: 0,
              rotate: 0,
            }}
            animate={{
              x: [0, -200 - Math.random() * 400],
              y: [0, -100 - Math.random() * 200, 100 + Math.random() * 200],
              opacity: [0, 1, 1, 0.8, 0],
              scale: [0, 1.2, 1, 0.8, 0],
              rotate: [0, -360 - Math.random() * 720],
            }}
            transition={{
              duration: 3 + Math.random() * 2,
              repeat: Infinity,
              delay: Math.random() * 4,
              ease: "easeOut",
            }}
          >
            {confettiShapes[Math.floor(Math.random() * confettiShapes.length)]}
          </motion.div>
        ))}
      </div>

      {/* Gradient Particles */}
      <div className="absolute inset-0">
        {[...Array(20)].map((_, i) => (
          <motion.div
            key={`particle-${i}`}
            className="absolute w-2 h-2 rounded-full"
            style={{
              background: `linear-gradient(45deg, ${confettiColors[Math.floor(Math.random() * confettiColors.length)]}, ${confettiColors[Math.floor(Math.random() * confettiColors.length)]})`,
              left: `${Math.random() * 100}%`,
              top: `${Math.random() * 100}%`,
            }}
            initial={{
              opacity: 0,
              scale: 0,
            }}
            animate={{
              opacity: [0, 1, 1, 0],
              scale: [0, 2, 1, 0],
              x: [0, (Math.random() - 0.5) * 200],
              y: [0, (Math.random() - 0.5) * 200],
            }}
            transition={{
              duration: 3 + Math.random() * 2,
              repeat: Infinity,
              delay: Math.random() * 5,
              ease: "easeOut",
            }}
          />
        ))}
      </div>
    </div>
  );
};

export default ConfettiExplosion; 